import type { ConnectedUserJwt } from "../tokens/jwt.dto";
import type { Flavor } from "../typeFlavors";
import type { NotEmptyArray } from "../utils";

export type FederatedIdentityProvider =
  (typeof federatedIdentityProviders)[number];

export const federatedIdentityProviders = [
  "proConnect",
  "email",
  "ftConnect",
] as const;

export const isFederatedIdentityProvider = (
  provider: string,
): provider is FederatedIdentityProvider =>
  federatedIdentityProviders.includes(provider as FederatedIdentityProvider);

type GenericFederatedIdentity<
  Provider extends FederatedIdentityProvider,
  T extends FtConnectToken | ConnectedUserJwt,
  P = void,
> = {
  provider: Provider;
  token: T;
  payload?: P;
};

export type FtExternalId = Flavor<string, "FtExternalId">;

export type WithFtConnectAdvisorForBeneficiary = {
  advisor?: FtConnectImmersionAdvisorDto;
};

export type FtConnectToken = FtExternalId;

export type FtConnectIdentity = GenericFederatedIdentity<
  "ftConnect",
  FtConnectToken,
  WithFtConnectAdvisorForBeneficiary
>;

export type FtConnectIdentityWithoutToken = Omit<FtConnectIdentity, "token">;

type ConnectedUserIdentity = GenericFederatedIdentity<
  "proConnect" | "email",
  ConnectedUserJwt
>;

export type FederatedIdentity = ConnectedUserIdentity;

const ftAdvisorImmersionKinds = ["PLACEMENT", "CAPEMPLOI"] as const;
export const ftAdvisorKinds = [
  ...ftAdvisorImmersionKinds,
  "INDEMNISATION",
] as const;

export const immersionFranceTravailAdvisors: NotEmptyArray<FtConnectImmersionAdvisorsKind> =
  ["PLACEMENT", "CAPEMPLOI"];

export type FtConnectImmersionAdvisorsKind =
  (typeof ftAdvisorImmersionKinds)[number];

export type FtConnectImmersionAdvisorDto = {
  email: string;
  firstName: string;
  lastName: string;
  type: FtConnectImmersionAdvisorsKind;
};
